import {withStyles} from "@mui/styles";
import React from "react";
import Paper from "@mui/material/Paper";
import styles from "./index.styles";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import {ListItemText} from "@mui/material";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import EnhancedTableToolbar from "./EnhancedTableToolBar.index";
import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import moment from "moment-timezone";
import {toast} from "react-toastify";
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  PHARMACY_REPORT_SORT_MAP,
} from "../../grid/iLocalAGGrid";


let TransactionFilterObj = {
  searchtext: "",
  fromdate: "",
  todate: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class UserInactiveReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      order: "desc",
      orderBy: "created_on",
      selected: [],
      Rows: [],
      page: 0,
      rowsPerPage: 10,
      data: [],
      isDataEmpty: false,
      searchText: "",
      selectedRowId: null,
      openUserDeleteDialog: false,
      userDeletionArr: [],
      disabledUserText: this.props.t("Report.inActive.Disable"),
      openUserDisabledDialog: false,
      userDisabledArr: [],
      totalRecords: 0,
      sortId: "",
      isButtonDisabled: false,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  componentDidMount = () => {
    // Mutate in place — SSRM datasource holds a reference to this object.
    TransactionFilterObj.searchtext = "";
    TransactionFilterObj.fromdate = "";
    TransactionFilterObj.todate = "";
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = 10;
    TransactionFilterObj.sortOrder = "desc";
    TransactionFilterObj.sortColumn = "created_on";
    TransactionFilterObj.tableName = "";
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID");
    this.fetchSuggestions();
  };

  getRowId = (params) => {
    const d = params.data || {};
    if (d.__ssrmId) return String(d.__ssrmId);
    return String(
      d.id ||
        [d.username, d.name, d.created_on, d.last_login_on]
          .filter((v) => v != null && String(v).trim() !== "")
          .join("|") ||
        `row-${Math.random().toString(36).slice(2)}`
    );
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  convertToTimeZone = (requestDate) => {
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return date
      .tz(zone.substring(zone.lastIndexOf(" ") + 1))
      .format("MM/DD/YYYY hh:mm:ss A");
  };

  handleClick = (event, id) => {
    const {selected} = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (
      ["user", "username", "createdon", "lastloginon", "status"].includes(field)
    ) {
      tablename = "users";
    }
    if (["associated account"].includes(field)) {
      tablename = "accounts";
    }
    if (["phone"].includes(field)) {
      tablename = "contacts";
    }
    if (["stock_code", "pucode"].includes(field)) {
      tablename = "prescriptions_master";
    }
    return tablename;
  };

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this._agFilterBody = TransactionFilterObj;
    const datasource = createServerSideDatasource({
      sortMap: PHARMACY_REPORT_SORT_MAP,
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, {
          dateColIds: ["lastloginon"],
        });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "inactiveuserreports", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...body,
            searchtext: body.searchtext || "",
            fromdate: body.fromdate || "",
            todate: body.todate || "",
          }),
        }).then((r) => r.json()),
      onSuccess: (results, total) => {
        setTimeout(() => {
          this.setState({
            data: results,
            totalRecords: total,
            loader: false,
            isDataEmpty: !results || results.length === 0,
            isButtonDisabled: !results || results.length === 0,
          });
        }, 0);
      },
      onError: () => this.setState({ loader: false }),
    });
    if (typeof params.api.setServerSideDatasource === "function") {
      params.api.setServerSideDatasource(datasource);
    }
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleContextClick = (event, n) => {
    event.preventDefault();
    let disabledText;
    if ((n && n.is_enabled) === "true" || (n && n.is_enabled) === true) {
      disabledText = this.props.t("Report.inActive.Disable");
    } else {
      disabledText = this.props.t("Report.inActive.Enable");
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.id,
      disabledUserText: disabledText,
    });
  };

  getDifferenceInDays = (sysDate, userDate) => {
    const diffInMs = Math.abs(sysDate - userDate);
    return diffInMs / (1000 * 60 * 60 * 24);
  };

  BindUsersGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race.
    this.setState({ loader: false });
  };

  handleSearchTextInput = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    event && event.preventDefault();
    this.setState({ searchText: event.target.value });
    TransactionFilterObj.searchtext = event.target.value;
    this.debouceTimeout = setTimeout(() => {
      this.BindUsersGrid();
    }, 1000)
  };

  handleConfirmDelete = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter(
            (x) => this.state && this.state.selected.indexOf(x.id) > -1
          ),
      });
    }
  };

  handleConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
      this.handleContextClose(event);
    } else
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
  };

  handleDeleteConfirmed = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDeleteUser(event);
    } else {
      this.handleDeleteMultipleUsers();
    }
    this.setState({ openUserDeleteDialog: false });
  };

  handleDeleteUser = (event) => {
    this.setState({ loader: true });
    const selecRowID = this.state && this.state.selectedRowId;
    fetch(process.env.REACT_APP_BASEURL + "users/" + selecRowID, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    }).then((results) => {
      this.setState({ loader: false });
      const _updatedUsers = this.state.data.filter(
        (x) => x.id !== this.state.selectedRowId
      );
      this.handleContextClose(event);
      this.setState({
        data: JSON.parse(JSON.stringify(_updatedUsers)),
        selected: [],
        selectedRowId: null,
      });
    });
  };

  handleDeleteMultipleUsers = () => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      "users/" +
      this.state.selected.join(",").trim(","),
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
    });
  };

  handleConfirmDisabled = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => this.state.selected.indexOf(x.id) > -1),
      });
    }
  };

  handleDisabledConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
    }
  };

  hanldeConfirmDisabledUsers = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDisabledUser(event);
      this.setState({ openUserDisabledDialog: false });
      toast.success(
        `${this.props.t('Toast.User')} ${this.state && this.state.disabledUserText} ${this.props.t('Toast.Success')}`
      );
    }
  };

  handleDisabledUser = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state.disabledUserText.toLowerCase() ===
          String(this.props.t("Report.inActive.Disable")).toLowerCase()
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + "userdis/", {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.BindUsersGrid();
    });
  };

  exportCSVReort = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "CSV/InActiveUserReport", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRows = [];
        let columns = [
          [
            "ID",
            "Name",
            "UserName",
            "Associated Account",
            "Phone",
            "Created On",
            "LastLogin On",
            "Status",
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== "undefined") {
          if (result && result.length > 0) {
            for (let i of result) {
              columns.push([
                i.name,
                i.username,
                i.accountname,
                i.phone,
                i.created_on ? this.convertToTimeZone(i && i.created_on) : "",
                i.last_login_on
                  ? this.convertToTimeZone(i && i.last_login_on)
                  : "",
                i.is_enabled === "true" || i.is_enabled === true
                  ? "Enabled"
                  : "Disabled",
              ]);
            }
          }

          for (let i of columns) {
            csvRows.push(i.join(","));
          }
          let csvString = csvRows.join("%0A");
          let element = document.createElement("a");
          element.href = "data:attachment/csv." + csvString;
          element.target = "_Blank";
          element.download = "InActiveUsersReport.csv";
          document.body.appendChild(element);
          element.click();
        }
      });
  };

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindUsersGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, t} = this.props;
    const {selected, anchorEl, loader, openUserDeleteDialog, userDeletionArr, isButtonDisabled} = this.state;
    const contextOpen = Boolean(anchorEl);
    return (
      <React.Fragment>
        {loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <Paper className={classes.root}>
          {/* Start Delete Dialog..*/}
          <Dialog
            open={openUserDeleteDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Report.inActive.AreYouSureText")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Report.inActive.AreYouSureBodyText")}
                <ul>
                  {userDeletionArr &&
                    userDeletionArr.length > 0 &&
                    userDeletionArr.map((ele, index) => {
                      return <li key={index}>{ele && ele.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.inActive.CancelButton")}
              </Button>
              <Button
                onClick={this.handleDeleteConfirmed}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Report.inActive.DeleteButton")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* End Delete Dialog..*/}
          {/* Start User Disable Dialog */}
          <Dialog
            open={this.state.openUserDisabledDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Report.inActive.AreYouSureWantTo")}{" "}
              {`${this.state && this.state.disabledUserText}?`}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Report.inActive.AreYouSureWantTo")}{" "}
                {this.state && this.state.disabledUserText} user(s):
                <ul>
                  {this.state.userDisabledArr &&
                    this.state.userDisabledArr.map(function (x) {
                      return <li>{x.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleDisabledConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.inActive.CancelButton")}
              </Button>
              <Button
                onClick={this.hanldeConfirmDisabledUsers}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Report.inActive.YesButton")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* End User Disabled Dialog.. */}
          <EnhancedTableToolbar
            NumRowsSelected={selected.length}
            OnConfirmDeleteUser={this.handleConfirmDelete}
            OnGenerateCSVReport={this.exportCSVReort}
            IsButtonDisabled={isButtonDisabled}
          />
          <div className={classes.tableWrapper}>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={contextOpen}
              onClose={this.handleContextClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: 200,
                },
              }}
            >
              <MenuItem
                key="Disable"
                onClick={this.handleConfirmDisabled}
                sx={{ height: "40px" }}
              >
                <ListItemText>
                  {this.state && this.state.disabledUserText}
                </ListItemText>
              </MenuItem>
              <MenuItem
                key="delete"
                onClick={this.handleConfirmDelete}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Report.inActive.Delete")}</ListItemText>
              </MenuItem>
            </Menu>
            <Divider
              style={{
                marginTop: "10px",
                height: "5px",
                borderColor: "rgba(0, 0, 0, 0.12)",
                borderStyle: "solid",
                borderBottomWidth: "5px",
              }}
            />
            <ILocalAGGrid
            columnDefs={[
              { field: 'picture_url', headerName: t("Report.inActive.Picture"), colId: 'picture', cellRenderer: (p) => p.value ? <img src={p.value} alt='' style={{height:32,width:32,borderRadius:'50%'}} /> : '' },
              { field: 'name', headerName: t("Report.inActive.Name"), colId: 'user' },
              { field: 'username', headerName: t("Report.inActive.UserName"), colId: 'username' },
              { field: 'accountname', headerName: t("Report.inActive.AssociatedAccount"), colId: 'associated account' },
              { field: 'phone', headerName: t("Report.inActive.Phone"), colId: 'phone' },
              {
                field: 'created_on',
                headerName: t("Report.inActive.CreatedOn"),
                colId: 'createdon',
                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
              },
              withDateColumnFilter({
                field: 'last_login_on',
                headerName: t("Report.inActive.LastLoginOn"),
                colId: 'lastloginon',
                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
              }),
              { field: 'is_enabled', headerName: t("Report.inActive.Status"), colId: 'status', valueFormatter: (p) => (p.value === true || p.value === 'true') ? 'Enabled' : 'Disabled' },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={this.getRowId}
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
          </div>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(withTranslation()(UserInactiveReport));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/index.js